
<h2 mat-dialog-title>Fjern kontaktperson</h2>

<mat-dialog-content class="mat-typography">

    <div class="flex-column flex-gap-20">
        <div class="message-text">Er du sikker på at du ønsker du å fjerne kontaktperson på denne saken?</div>
        <div *ngIf="!hasComplainerKey" class="alert-warning" [innerHtml]="removeElComMessage | safe: 'html'"></div>        
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" class="finkn-btn" color="primary" mat-raised-button (click)="approve()">Ok</button>
    <button type="button" class="finkn-btn" color="primary" mat-raised-button (click)="deny()">Avbryt</button>
</mat-dialog-actions>